import React, { useState, useContext, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { Dropdown } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//Import Components
import { ThemeContext } from "../../../context/ThemeContext";
import VacanyTab from "../Jobick/Home/VacanyTab";
import CanvasChartTab from "../Jobick/Home/CanvasChartTab";
import FeaturedCompanies from "../Jobick/Home/FeaturedCompanies";
import RecentActivity from "../Jobick/Home/RecentActivity";
import HomeSlider from "../Jobick/Home/HomeSlider";
import { dashboardCandidateAPI } from "../../api/dashboard";
import DashboardJobs from "./DashboardJobs";
import DashboardRecruiter from "./DashboardRecruiter";

//import FinancialChartMultipleData from './FinancialChartMultipleData';

//Images
import pic1 from "./../../../images/profile/pic1.jpg";
import { connect, useSelector } from "react-redux";
import DashboardEditor from "./DashboardEditor";
import { sidebarAPI } from "../../api/menu";
//import { color } from "html2canvas/dist/types/css/types/color";
//import useAccess from "../../api/useAccess";

//Components
const NewCustomers1 = loadable(() =>
  pMinDelay(import("../Jobick/Home/NewCustomers1"), 1000)
);
const NewCustomers2 = loadable(() =>
  pMinDelay(import("../Jobick/Home/NewCustomers2"), 1000)
);
const NewCustomers3 = loadable(() =>
  pMinDelay(import("../Jobick/Home/NewCustomers3"), 1000)
);
const NewCustomers4 = loadable(() =>
  pMinDelay(import("../Jobick/Home/NewCustomers4"), 1000)
);
const PieChartDashboard = loadable(() =>
  pMinDelay(import("./pieChartDashboard"), 1000)
);

const Home = (props) => {
  //console.log(props.user);

  const { dashboard_box } = props.user;
  const roleName = useSelector((state) => state.auth?.auth?.roleName);

  const [startDate, setStartDate] = useState("");

  const { changeBackground, background } = useContext(ThemeContext);
  const [appl, setApp] = useState({});
  //const {fetchAccess} = useAccess();
  const [dashboardBox, setDashboardBox] = useState([]);
  const [menuList, setMenuList] = useState([]);
  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
    fetchApplicationData();
    setMenu();
  }, []);

  const saveDashboardBox = useCallback(
    (boxdata) => {
      const boxArray = boxdata.split(",");
      setDashboardBox(boxArray);
    },
    [setDashboardBox]
  );

  useEffect(() => {
    if (dashboard_box) {
      saveDashboardBox(dashboard_box);
    }
  }, [dashboard_box]);

  const [control3, setControl3] = useState("Newest");
  const fetchApplicationData = async () => {
    let d = await dashboardCandidateAPI();
    //console.log("Application Data", d, );
    setApp(d);
  };

  const setMenu = useCallback(async () => {
    let pdata = JSON.parse(localStorage.getItem("userDetails"));
    let mdata = await sidebarAPI(pdata.roleid);
    if (mdata === false) {
      setMenuList([]);
    } else {
      const access = [];
      mdata.forEach((element) => {
        access.push(element.to);
      });
      setMenuList(access);
    }
  }, []);

  return (
    <>
      {roleName === "Super Admin" && (
        <div className="row">
          <div className="col-md-12 mb-3">
            <Link to={"/dashboard-history"} className="btn btn-info">
              View History
            </Link>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-xl-6">
          <div className="row">
            <div className="col-xl-12">
              {dashboardBox.includes("AAP") && menuList.includes("c_lists") && (
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between">
                      <h5 className="card-title">All Applicants</h5>
                    </div>
                    <hr />
                    <div className="row separate-row">
                      <div className="col-sm-6 fw-bolder">
                        <div className="job-icon pb-4 d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1" style={{ "color": "#f93a0b" }}>
                                  {appl?.total_candidate}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.total_candidate_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2" style={{ "color": "#f93a0b" }}>
                                Total Applications
                              </span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.total_candidate}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.total_candidate_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                Total Applications
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6 fw-bolder">
                        <div className="job-icon pb-4 pt-4 pt-sm-0 d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists?filter=today">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1" style={{ "color": "#f93a0b" }}>
                                  {appl?.today_candidate}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.today_candidate_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2" style={{ "color": "#f93a0b" }}>
                                Applications Today
                              </span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.today_candidate}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.today_candidate_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                Applications Today
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6 fw-bolder">
                        <div className="job-icon pt-4  d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists?filter=no-resume">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1" style={{ "color": "#f93a0b" }}>{appl?.no_resume}</h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.no_resume_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2" style={{ "color": "#f93a0b" }}>
                                No Resume
                              </span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">{appl?.no_resume}</h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.no_resume_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                No Resume
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div
                        className="col-sm-6 fw-bolder"
                        style={{ "border-bottom": "1px solid #eee" }}
                      >
                        <div className="job-icon pt-4  d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists?lgbt_status=0">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1" style={{ "color": "#f93a0b" }}>
                                  {appl?.lgbt_unverified}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.lgbt_unverified_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2" style={{ "color": "#f93a0b" }}>
                                Pending Verification
                              </span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.lgbt_unverified}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.lgbt_unverified_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                Pending Verification
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6 fw-bolder">
                        <div className="job-icon pt-4  d-flex justify-content-between">
                          <div>
                            <div className="d-flex align-items-center mb-1">
                              <h2 className="mb-0 lh-1" style={{ "color": "#f93a0b" }}>
                                {appl?.applicants_from}
                              </h2>
                              <i
                                className={`fa-solid ms-3 ${appl?.applicants_from_flag}`}
                              ></i>
                            </div>
                            <span className="fs-14 d-block mb-2" style={{ "color": "#f93a0b" }}>
                              Locations
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6 fw-bolder">
                        <div className="job-icon pt-4  d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists?reason=Hold for 3 Months (Job Secured)">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1" style={{ "color": "#f93a0b" }}>{appl?.onhold_candidate}</h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.onhold_candidate_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2" style={{ "color": "#f93a0b" }}>
                                Candidates on Hold/Offered
                              </span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">{appl?.onhold_candidate}</h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.onhold_candidate_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                Candidates on Hold/Offered
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div
                        className="col-sm-6"
                        style={{ "border-bottom": "1px solid #eee" }}
                      >
                        <div className="job-icon pt-4 pb-sm-0 pb-4 pe-3 d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists?lgbt_status=1">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.active_candidate}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.active_candidate_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                LGBT+ Active Candidates
                              </span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.active_candidate}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.active_candidate_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                LGBT+ Active Candidates
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="job-icon pt-4  d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists?lgbt_status=3">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">{appl?.nonLgbt}</h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.nonLgbt_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                Non-LGBT+ Total Applications
                              </span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">{appl?.nonLgbt}</h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.nonLgbt_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                Non-LGBT+ Total Applications
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="job-icon pt-4  d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists?identify_as=16">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.nonLgbt_woman}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.nonLgbt_woman_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">Women Total Candidates</span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.nonLgbt_woman}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.nonLgbt_woman_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">Women Total Candidates</span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="job-icon pt-4  d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists?identify_as=15">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.nonLgbt_man}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.nonLgbt_man_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">Men Total Candidates</span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.nonLgbt_man}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.nonLgbt_man_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">Men Total Candidates</span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="job-icon pt-4  d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists?identify_as=16">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.nonLgbt_active_woman}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.nonLgbt_active_woman_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">Women Active Candidates</span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.nonLgbt_active_woman}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.nonLgbt_active_woman_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">Women Active Candidates</span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="job-icon pt-4  d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists?identify_as=15">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.nonLgbt_active_man}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.nonLgbt_active_man_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">Men Active Candidates</span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.nonLgbt_active_man}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.nonLgbt_active_man_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">Men Active Candidates</span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="job-icon pt-4  d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists?reason=Candidate Delete Request">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.delrequest_candidate}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.delrequest_candidate_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                Delete Request (All)
                              </span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.delrequest_candidate}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.delrequest_candidate_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                Delete Request (All)
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="job-icon pt-4  d-flex justify-content-between">
                          {roleName === "Super Admin" ? (
                            <Link to="/c_lists?reason=Blacklisted">
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.blacklisted_candidate}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.blacklisted_candidate_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                Blacklisted Candidates (All)
                              </span>
                            </Link>
                          ) : (
                            <div>
                              <div className="d-flex align-items-center mb-1">
                                <h2 className="mb-0 lh-1">
                                  {appl?.blacklisted_candidate}
                                </h2>
                                <i
                                  className={`fa-solid ms-3 ${appl?.blacklisted_candidate_flag}`}
                                ></i>
                              </div>
                              <span className="fs-14 d-block mb-2">
                                Blacklisted Candidates (All)
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      
                    </div>
                  </div>
                </div>
              )}
            </div>
            {dashboardBox.includes("RCT") &&
              menuList.includes("recruiter_list") && <DashboardRecruiter />}
            {dashboardBox.includes("JOB") && menuList.includes("job_list") && (
              <DashboardJobs />
            )}
            {dashboardBox.includes("EDT") && <DashboardEditor />}
          </div>
        </div>
        <div className="col-xl-6">
          <div className="row">
            {dashboardBox.includes("SKL") && (
              <PieChartDashboard type="Skills" />
            )}
            {dashboardBox.includes("LOC") && (
              <PieChartDashboard type="Locations" />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  const { auth } = state;
  return { user: auth?.auth };
}

export default connect(mapStateToProps)(Home);
